import { createContext, useState, useCallback, type ReactNode } from 'react'
import type { DateFrom } from './types'

export interface PostHogParams {
  date_from: DateFrom
  event_name: string
  setEventName: (event_name: string) => void
  setDateFrom: (date_from: DateFrom) => void
}

export const initialPosthogParams: PostHogParams = {
  date_from: 7,
  event_name: '$pageview',
  setEventName: () => {},
  setDateFrom: () => {},
}

export const PostHogContext = createContext<PostHogParams>(initialPosthogParams)

export interface PostHogProviderProps {
  children: ReactNode
}

export function PostHogProvider({ children }: PostHogProviderProps) {
  const [date_from, setDateFrom] = useState<DateFrom>(7)
  const [event_name, setEventName] = useState<string>('$pageview')

  const handleSetEventName = useCallback((newEventName: string) => {
    setEventName(newEventName)
  }, [])

  const handleSetDateFrom = useCallback((newDateFrom: DateFrom) => {
    setDateFrom(newDateFrom)
  }, [])

  const value: PostHogParams = {
    date_from,
    event_name,
    setEventName: handleSetEventName,
    setDateFrom: handleSetDateFrom,
  }

  return (
    <PostHogContext.Provider value={value}>{children}</PostHogContext.Provider>
  )
}
